var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-drawer',{ref:"drawer",staticClass:"app-drawer",attrs:{"size":_vm.size,"destroy-on-close":true,"before-close":_vm.beforeClose,"visible":_vm.viewDrawer,"title":_vm.title,"wrapperClosable":_vm.wrapperClosable},on:{"close":_vm.closeDrawer,"update:visible":function($event){_vm.viewDrawer=$event}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }